import { FlowBlockType, FlowObsoleteBlockType } from 'flow-schema';

import {
  type FlowDefinitionBlockCompatibilityByBlockType,
  FlowDefinitionBlockTypeCompatibility,
} from './types.js';
import { UnknownBlockType } from '../base/baseSchema.js';

export const FLOW_TEMPLATE_BLOCK_TYPE_COMPATIBILITY: FlowDefinitionBlockCompatibilityByBlockType = {
  [FlowBlockType.Start]: FlowDefinitionBlockTypeCompatibility.Required,
  [FlowBlockType.Output]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.SubFlowV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.IteratorV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Repeat]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Conditional]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Switch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.ScriptedFlow]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Text]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.FilterList]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.WaitV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.UpdateFlowConfig]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.LlmPrompt]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Evaluation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.MedicalNecessityCheck]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Fhir]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.OcrV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.InformationExtraction]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.VoiceCallV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.VoiceTranscribe]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.HieQueryDocuments]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.HieGetDocuments]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.WaitForFormCompletion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Conversation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.AdvancedFhir]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.HCCAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.DocumentTemplate]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GenerateFile]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.PatientDataStore]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Rest]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.Form]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.FormV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetFormSet]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetInsurances]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.SendEmail]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.SendSms]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.AutomatedVoice]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Fax]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.HumanTask]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.UpdateNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Hl7]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Mirth]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.MontageOnBase]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.RealTimeEligibility]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.InsuranceCard]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.FileConversion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.WaitForSignal]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Callback]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.CareGapAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.DocumentExtract]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetPatient]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetPatientOrder]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetProvider]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.ExportExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.ExportTextToBucket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.ExportToSftp]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.CreateEncounterSummary]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.CreatePatientOrder]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.AsynchronousExportJob]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.CreateNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.DocumentSearch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetSftpFile]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.ServiceReview]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.SkillV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  // Retired blocks
  [FlowBlockType.AuthorizationSubmission]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Wait]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.IteratorV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.SubFlowV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.VoiceCall]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Ocr]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.RestApiClassicAuthorization]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Scheduling]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.AsynchronousExtractJob]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  // Obsolete blocks
  [FlowObsoleteBlockType.ObsoleteApiSubmissions]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteGetEncounterSummary]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteHumanReview]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSkill]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSendToLabelboxForReview]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteWaitForAvailableSchedulingSlot]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  // A flow-api test harness block: it has no block_type_metadata row, so it is never pickable.
  [FlowBlockType.TestLifecycle]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [UnknownBlockType.Unknown]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
};
